import { useLocation, useParams } from 'quartz-routing/react-router';
import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { ACRedirect } from 'academy-common-lib/components/ACRedirect';
import { ACRouterButton } from 'academy-common-lib/components/ACRouterButton';
import ErrorBoundary from '../../../components/Errors/ErrorBoundary';
import UsageTracker from '../../../utils/UsageTracker';
import CertificationsByTeamActiveTab from '../components/certificationsByTeam/CertificationsByTeamActiveTab';
import CertificationsByTeamExpiredTab from '../components/certificationsByTeam/CertificationsByTeamExpiredTab';
import CertificationsByTeamInProgressTab from '../components/certificationsByTeam/CertificationsByTeamInProgressTab';
import Card from '../components/common/Card';
import { PAGE_NAMES } from '../../../constants/Navigation.legacy';
import { FiltersCard } from 'academy-common-lib/features/filters/components/FiltersCard';
import { PageHeader } from '../../header/components/PageHeader';
import { getBreadcrumbItem } from '../constants/breadcrumbs';
import { ACTIVE_CERTIFICATIONS_BY_TEAM_PATH, EXPIRED_CERTIFICATIONS_BY_TEAM_PATH, IN_PROGRESS_CERTIFICATIONS_BY_TEAM_PATH } from '../constants/routes';
import { removePageParam } from '../utils/paginationUtils';
import { trackCertificationStatusChange } from '../utils/trackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RedirectToCertificationsByTeamDefaultTab = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  return /*#__PURE__*/_jsx(ACRedirect, {
    to: Object.assign({}, location, {
      pathname: `${pathname}/active`
    })
  });
};
const MyTeamCertificationsByTeam = () => {
  const {
    certificationStatus
  } = useParams();
  const location = useLocation();
  const breadcrumbs = [getBreadcrumbItem({
    pageKey: 'MY_TEAM'
  }), getBreadcrumbItem({
    pageKey: 'MY_TEAM_MEMBERS'
  }), getBreadcrumbItem({
    pageKey: 'MY_TEAM_CERTIFICATIONS_BY_TEAM',
    isCurrent: true
  })];
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: PAGE_NAMES.MY_TEAM_CERTIFICATIONS_BY_TEAM
    });
  }, []);
  useEffect(() => {
    trackCertificationStatusChange(certificationStatus);
  }, [certificationStatus]);
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(PageHeader, {
      breadcrumbs: breadcrumbs,
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingSubTitles.MY_TEAM_CERTIFICATIONS_BY_TEAM"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingTitles.MY_TEAM_CERTIFICATIONS_BY_TEAM"
      })
    }), /*#__PURE__*/_jsx(FiltersCard, {
      paddingBlock: "400",
      paddingInline: "400",
      children: /*#__PURE__*/_jsxs(ButtonGroup, {
        children: [/*#__PURE__*/_jsx(ACRouterButton, {
          active: certificationStatus === 'active',
          replace: true,
          to: {
            pathname: ACTIVE_CERTIFICATIONS_BY_TEAM_PATH,
            search: removePageParam(location.search)
          },
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.certificationStatus.active"
          })
        }), /*#__PURE__*/_jsx(ACRouterButton, {
          active: certificationStatus === 'expired',
          replace: true,
          to: {
            pathname: EXPIRED_CERTIFICATIONS_BY_TEAM_PATH,
            search: removePageParam(location.search)
          },
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.certificationStatus.expired"
          })
        }), /*#__PURE__*/_jsx(ACRouterButton, {
          active: certificationStatus === 'in-progress',
          replace: true,
          to: {
            pathname: IN_PROGRESS_CERTIFICATIONS_BY_TEAM_PATH,
            search: removePageParam(location.search)
          },
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.certificationStatus.inProgress"
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(Card, {
      children: [certificationStatus === 'active' && /*#__PURE__*/_jsx(ErrorBoundary, {
        boundaryName: "CertificationsByTeamActiveTab",
        children: /*#__PURE__*/_jsx(CertificationsByTeamActiveTab, {})
      }), certificationStatus === 'expired' && /*#__PURE__*/_jsx(ErrorBoundary, {
        boundaryName: "CertificationsByTeamExpiredTab",
        children: /*#__PURE__*/_jsx(CertificationsByTeamExpiredTab, {})
      }), certificationStatus === 'in-progress' && /*#__PURE__*/_jsx(ErrorBoundary, {
        boundaryName: "CertificationsByTeamInProgressTab",
        children: /*#__PURE__*/_jsx(CertificationsByTeamInProgressTab, {})
      })]
    })]
  });
};
export default MyTeamCertificationsByTeam;